
export const mostrarMensagemSucesso = (mensagemToast,detail) => {
    mensagemToast.current.show({
        severity: 'success',
        summary: 'Sucesso',
        detail,
        life: 4000,
        closable: false
    });
};

export const mostrarMensagemErro = (mensagemToast,detail) => {
    mensagemToast.current.show({
        severity: 'error',
        summary: 'Erro',
        detail,
        life: 4000,
        closable: false
    });
};
